import { fetchWrapper } from "_helpers";

const baseUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_CONTEXT_PATH}/application-document`;



export const ApplicationDocumentService = {
  downloadDocument,
  downloadSubDocument,
  getAll,
  search,
  getSuggestion,
  getById,
  create,
  update,
  delete: _delete,
  uploadSubDocument,
  getSubDocumentByCompanyId,
};

function getAll() {
  return fetchWrapper.get(baseUrl);
}

function search(params) {
  return fetchWrapper.get(`${baseUrl}${params}`);
}

function getSuggestion(params) {
  return fetchWrapper.get(`${baseUrl}/suggestion${params}`);
}


function getById(id) {
  return fetchWrapper.get(`${baseUrl}/${id}/view`);
}

function getSubDocumentByCompanyId(companyId) {
  return fetchWrapper.get(`${baseUrl}/sub-document/${companyId}/view`);
}

function create(params) {
  return fetchWrapper.post(baseUrl, params);
}

// function uploadFile(params) {
//   return fetchWrapper.post(`${baseUrl}/upload`, params);
// }

function update(id, params) {
  return fetchWrapper.put(`${baseUrl}/${id}`, params);
}

function _delete(id) {
  return fetchWrapper.delete(`${baseUrl}/${id}`);
}

function uploadSubDocument(companyId, params) {
  return fetchWrapper.post(`${baseUrl}/sub-document/upload/${companyId}`, params);
}

function downloadDocument(id) {
  return fetchWrapper.get(`${baseUrl}/${id}`, { responseType: "blob" });
}

function downloadSubDocument(id) {
  return fetchWrapper.get(`${baseUrl}/sub-document/${id}/download`, { responseType: "blob" });
}
